import type { ReactNode } from 'react'
import styles from './OpportunityDetailsContent.module.css'
import { Icon, type IconName } from '@/components/Icon'

export interface OpportunityDetailsContentProps {
  children: ReactNode
}

export function OpportunityDetailsContent({
  children,
}: OpportunityDetailsContentProps) {
  return <div className={styles.content}>{children}</div>
}

export interface OpportunityDetailsContentItemProps {
  title: string
  icon?: IconName
  children?: ReactNode
}

export function OpportunityDetailsContentItem({
  title,
  icon,
  children,
}: OpportunityDetailsContentItemProps) {
  return (
    <div className={styles.contentItem}>
      <p className={styles.contentItemTitle}>{title}</p>
      <div className={styles.contentItemValue}>
        {icon && (
          <span className={styles.contentItemIcon}>
            <Icon auto name={icon} />
          </span>
        )}
        <span className={styles.contentItemText}>{children}</span>
      </div>
    </div>
  )
}

export interface NoInfoProps {
  children: ReactNode
}

export function NoInfo({ children }: NoInfoProps) {
  return <p className={styles.noInfo}>{children}</p>
}
